import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './app'
import { sync } from 'vuex-router-sync'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import navmenu from './components/navmenu'
import lodash from 'lodash'

import router from './config/routes'
import store from './store/'
import './style/common.scss'
import './style/ai.scss'
import './assets/iconfont/iconfont.js'
import './assets/iconfont/iconfont.css'
// import '../utils/browserupgrade.js'

import track from './utils/track'

Vue.use(Element)
Vue.use(VueResource)
Vue.use(lodash)
Vue.http.options.emulateJSON = true
sync(store, router)

import './components/AiTopNav/style.v0.4.1.css';

Vue.component('navmenu', navmenu)

const vm = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

vm.$router.beforeEach(({ meta, path }, from, next) => {
  /*
    page track
  */
  const userId = vm.$store.state.user.userId
  const toPath = path
  const fromPath = from.path
  track({ module: 'error', userId, toPath, fromPath })
  next()
})



// WEBPACK FOOTER //
// ./src/main.js